export default __webpack_public_path__ + "static/media/offer-warning.2f81f4c1.svg";